import { formatUnknownRecordValueForDisplay } from "#src/utils/formatUnknownRecordValueForDisplay";
import { Tag } from "@validereinc/common-components";
import React from "react";

export type KeyValueTagsRecordType = Record<string, unknown>;

export type KeyValueTagsPropsType = {
  record: KeyValueTagsRecordType;
  tagsContainerStyle?: React.CSSProperties;
  emptyStateStyle?: React.CSSProperties;
};

/**
 * Renders a key/value record as tags and shows an em dash when empty.
 */
export const KeyValueTags = ({
  record,
  tagsContainerStyle,
  emptyStateStyle,
}: KeyValueTagsPropsType) => {
  const entries = Object.entries(record ?? {});
  if (entries.length === 0) {
    return <span style={emptyStateStyle}>—</span>;
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        alignItems: "center",
        ...tagsContainerStyle,
      }}
    >
      {entries.map(([key, value]) => (
        <Tag
          key={key}
          label={key}
          value={formatUnknownRecordValueForDisplay(value)}
          style={{ maxWidth: 400 }}
          valueAs={({ ...props }) => (
            <div
              {...props}
              style={{
                maxWidth: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            />
          )}
        />
      ))}
    </div>
  );
};
